export const instanceTypeFilterTypes: Set<string> = new Set([
  "instance_type",
  "node_type",
]);
